import { Store } from "lucide-react";
import { useLocation } from "react-router-dom";
import StoreBranches from "./StoreBranches";
import StoreCatalogs from "./StoreCatalogs";
import Navbar from "../Home/Navbar";
import Footer from "../Home/Footer";
import AuthModal from "../Auth/AuthModal.jsx";
import { useState } from "react";
import { setDocumentTitle, setMetaDescription } from "../../utils/seo";
import { useEffect } from "react";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";






export default function StoreDetails({selectedArea, setSelectedArea , isLoggedIn, setIsLoggedIn , setShowAuthModal , showAuthModal} ) {
  // const { state: store } = useLocation();
  const { storeName , storeId  } = useParams();

  const [catalog , setCatalog] = useState([]);
  const navigate = useNavigate();
  
  // Set SEO title and description for store details page
    useEffect(() => {
    if (storeName) {
      setDocumentTitle(storeName + " | Gulf Deals UAE");
    }
  }, [storeName]);

  return (
    <div className="">
              {/* Top nav */}
      <Navbar
        selectedArea={selectedArea}
        setSelectedArea={setSelectedArea}
        isLoggedIn={isLoggedIn}
        setIsLoggedIn={setIsLoggedIn}
        onLoginClick={() => setShowAuthModal(true)}
      />
      <div className='max-w-6xl p-6'>
      <button onClick={() => navigate(`/Store`)}>
        <ArrowLeft size={20} />
      </button>
      </div>
        <StoreCatalogs storeId={storeId} storeName={storeName} onSelectCatalog={setCatalog} selectedCat={catalog} />

        <StoreBranches storeId={storeId} />
        <Footer/>
        {showAuthModal && (
          <AuthModal
            onClose={() => setShowAuthModal(false)}
            setIsLoggedIn={setIsLoggedIn}
          />
        )}
    </div>
  );
}
